/**
 *  판매점 리스트 필터 옵션 모델
 */
export const ACCOUNT_SELLER_LIST_FILTER_OPTION_MODEL = {
  /**
   *  판매점 상태
   */
  status: null,
  /**
   *  회원번호
   */
  storeId: null,
  /**
   *  판매점 명
   */
  storeName: null,
  /**
   *  판매자 유형
   */
  businessType: null,
  /**
   *  담당자
   */
  name: null,
  /**
   *  이메일
   */
  email: null,
  /**
   *  핸드폰
   */
  phone: null,
  /**
   *  유선전화
   */
  extraPhone: null,
  /**
   *  매장상주지역
   */
  city: null,
  /**
   *  전자세금계산서 이메일
   */
  storeEmail: null,
};

/**
 *  판매점 리스트 정렬 옵션 모델
 */
export const ACCOUNT_SELLER_LIST_SORT_OPTION_MODEL = {
  sort: '',
};

export const ACCOUNT_SELLER_LIST_SORT_PAGINATION_MODEL = {
  pageIndex: 1,
  pageSize: 100,
};
